//Defaults Apps constants 

export const LOADING = 'LOADING'